<template>
    <v-container class="pa-4">
        <v-data-table
            :headers="headers"
            :items="list"
            class="elevation-5"
            :loading="loading"
            :server-items-length="total"
            :page.sync="page"
            @page-count="pageCount = $event"
            @update:page="sync"
            hide-default-footer
            disable-sort
        >
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>{{ title }}</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="clickCreate">新增</v-btn>
                    <confirm-dialog
                        ref="confirmDialog"
                        :handleSubmit="handleDelete"
                    />
                </v-toolbar>
                <v-row>
                    <search v-model="query" @change="changeFilter" />
                </v-row>
            </template>
            <template v-slot:footer>
                <v-pagination
                    v-if="pageCount > 0"
                    class="py-2"
                    v-model="page"
                    :length="pageCount"
                    :total-visible="7"
                ></v-pagination>
            </template>
            <template v-slot:[`item.serial`]="{ index }">
                {{ itemIndex(index + 1) }}
            </template>
            <template v-slot:[`item.title`]="{ item }">
                {{ item.title["zhTw"] }}
            </template>
            <template v-slot:[`item.online`]="{ item }">
                {{ item.online ? "開啟" : "關閉" }}
            </template>
            <template v-slot:[`item.updateAt`]="{ item }">
                {{ item.updateAt | moment("YYYY/MM/DD") }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-icon small class="mr-2" @click="handleMove(item, 'up')">
                    mdi-arrow-up-bold
                </v-icon>
                <v-icon small class="mr-2" @click="handleMove(item, 'down')">
                    mdi-arrow-down-bold
                </v-icon>
                <v-icon small class="mr-2" @click="clickUpdate(item)">
                    mdi-pencil
                </v-icon>
                <v-icon small @click="showDeleteDialog(item)">
                    mdi-delete
                </v-icon>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import ConfirmDialog from '@/components/dialog/ConfirmDialog.vue';
import OperationMixin from '@/views/mixins/OperationMixin';
import Search from '@/components/Search.vue';

export default {
    mixins: [OperationMixin],
    components: {
        ConfirmDialog,
        Search,
    },
    data: () => ({
        headers: [
            { text: '序號', value: 'serial' },
            { text: '活動名稱', value: 'title' },
            { text: '更新時間', value: 'updateAt' },
            { text: '編輯者', value: 'modifiedBy' },
            { text: '狀態', value: 'online' },
            { text: '操作', value: 'actions', sortable: false },
        ],
    }),
    computed: {
        ...mapState('event', ['list', 'total']),
        ...mapGetters('category', ['categoryOptions']),
        title() {
            return '影像集錦';
        },
        fields() {
            return [{
                name: '標題', type: 'text-i18n', key: 'title', required: true,
            }, {
                name: '圖片上傳',
                type: 'options',
                key: 'files',
                elementName: '圖片',
                required: true,
                subfields: [
                    { name: '標題', type: 'text-i18n', key: 'title' },
                    {
                        name: '檔案', type: 'image', key: 'url', accept: 'image/*',
                    },
                ],
            }, {
                name: '影片連結',
                type: 'options',
                key: 'videos',
                elementName: '影片',
                required: true,
                subfields: [
                    { name: '標題', type: 'text-i18n', key: 'title' },
                    { name: '網址', type: 'text', key: 'url' },
                ],
            }, {
                name: '狀態',
                type: 'radio',
                key: 'online',
                items: [
                    { text: '開啟', value: true },
                    { text: '關閉', value: false },
                ],
                required: true,
            },
            ];
        },
    },
    methods: {
        ...mapActions('event', ['fetch', 'delete', 'move']),
        clickCreate() {
            this.$router.push({
                name: 'Form',
                params: {
                    name: this.title,
                    resource: 'event',
                    fields: this.fields,
                },
            });
        },
        clickUpdate(data) {
            this.$router.push({
                name: 'Form',
                params: {
                    name: this.title,
                    resource: 'event',
                    fields: this.fields,
                    payload: data,
                },
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.row {
    margin: 12px !important;
}
</style>
